<script lang="ts">
  import IntroPartial from '$components/common/partials/IntroPartial.svelte';
  import BoxFixesPartial from '$components/common/partials/BoxFixesPartial.svelte';
  import RichTextFixesPartial from '$components/common/partials/RichTextFixesPartial.svelte';
  import LinkFixesPartial from '$components/common/partials/LinkFixesPartial.svelte';
  import VideoFixesPartial from '$components/common/partials/VideoFixesPartial.svelte';
  import LinkVideoArrowPartial from '$components/common/partials/LinkVideoArrowPartial.svelte';
  import NavFullWidthBorderPartial from '$components/common/partials/NavFullWidthBorderPartial.svelte';
  import type { EdiPageStylesProps } from './types';

  export let navWithFullWidthBorder: EdiPageStylesProps['navWithFullWidthBorder'];
</script>

<IntroPartial />
<BoxFixesPartial />
<RichTextFixesPartial />
<LinkFixesPartial />
<VideoFixesPartial />
<LinkVideoArrowPartial />

{#if navWithFullWidthBorder}
  <NavFullWidthBorderPartial />
{/if}
